import { StylingModel } from '../style/styling.model';
import { CoreStylingModel } from '../core/core-styling.model';
export class TabsStylingModel extends CoreStylingModel {
/**
 * Styling of wizard header section
 */
headerSection?: StylingModel;
/**
 * @hidden 
 * It is the constructor for the TabsStylingModel. It takes the values to create the TabsStylingModel object.
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function TabsStylingModel_tsickle_Closure_declarations() {
/**
 * Styling of wizard header section
 * @type {?}
 */
TabsStylingModel.prototype.headerSection;
}

